import favoriteStore from '../stores';

document.addEventListener('toggle-initial-favorites', function (event) {
    const tweakwiseVehicleCards = document.querySelectorAll('.twn-starter__products-item');
    if (tweakwiseVehicleCards) {

        const favorites = favoriteStore.getItems();

        tweakwiseVehicleCards.forEach(function (element) {
            const productId = element.id.replace('twn-', '');

            const isFavorite = favorites.some(favorite => {
                return favorite.vehicle_id === parseInt(productId, 10);
            });

            if (isFavorite) {
                const favoritesButton = element.querySelector('.twn-product-tile__favorites-button');
                if (favoritesButton) {
                    favoritesButton.classList.add('is-added');
                }
            }
        });
    }
});
